import { goi } from './api';

/**
 * Kiểm ảnh sản phẩm TRÊN TRÌNH DUYỆT trước khi gửi (14/09): cùng chuẩn với
 * server (`anh-san-pham.service.ts`) và với `chuan-hoa-anh-san-pham.py`:
 * JPEG · vuông · cạnh ≤ 512 · ≤ 300 KB. Đọc kích thước bằng cách nạp thật vào
 * <img> — trình duyệt tự giải mã, không phải parse header ở đây.
 */
export const ANH_TOI_DA_CANH = 512;
export const ANH_TOI_DA_KB = 300;

export function kiemAnhSanPham(f: File): Promise<{ loi: string | null; rong?: number; cao?: number }> {
  return new Promise((xong) => {
    const tenOk = /\.(jpe?g)$/i.test(f.name);
    if (f.type !== 'image/jpeg' && !tenOk) {
      xong({ loi: `"${f.name}" không phải JPG. Chỉ nhận .jpg — PNG/HEIC thì đổi sang JPG trước.` });
      return;
    }
    if (f.size > ANH_TOI_DA_KB * 1024) {
      xong({ loi: `Ảnh ${Math.round(f.size / 1024)} KB, tối đa ${ANH_TOI_DA_KB} KB. Ảnh 512×512 JPG thường 15–30 KB.` });
      return;
    }
    const url = URL.createObjectURL(f);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const { naturalWidth: rong, naturalHeight: cao } = img;
      if (rong !== cao) xong({ loi: `Ảnh ${rong}×${cao} không vuông. Cắt vuông trước khi đưa lên.`, rong, cao });
      else if (rong > ANH_TOI_DA_CANH) xong({ loi: `Ảnh ${rong}×${cao} lớn hơn ${ANH_TOI_DA_CANH}×${ANH_TOI_DA_CANH}. Thu nhỏ trước.`, rong, cao });
      else xong({ loi: null, rong, cao });
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      xong({ loi: 'Không đọc được file ảnh này.' });
    };
    img.src = url;
  });
}

/** POST /api/san-pham/:id/anh — multipart, trường "file". Trả đường dẫn mới. */
export function taiAnhSanPham(sanPhamId: number, f: File) {
  const fd = new FormData();
  fd.append('file', f, f.name);
  return goi<{ san_pham_id: number; anh: string; rong: number; kb: number }>(`/api/san-pham/${sanPhamId}/anh`, {
    method: 'POST',
    than: fd,
  });
}
